var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.67188 13L7.76461 6.89235L1.67187 1.01407","stroke":"#6A7BB4","strokeWidth":"2","strokeLinejoin":"round"}));
}

ArrowRight.defaultProps = {"width":"9","height":"14","viewBox":"0 0 9 14","fill":"none"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
